export default function DateInput({ value, onChange }) {
  return (
    <input
      type="date"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="rounded-lg border py-2 pl-3 pr-2 text-sm dark:border-white/10 dark:bg-navy-800 dark:text-white"
    />
  );
}
